import React from "react"
import AccordionView from "./accordion/AccordionView"
import TabsView from "./tabs/TabsView"

const propsAreEqual = (prevProps, nextProps) => {
  if (nextProps.layout !== prevProps.layout) return false
  return true
}

const CardsView = React.memo((props) => {
  const { layout } = props

  if (layout === "accordion") {
    return <AccordionView {...props} />
  }

  if (layout === "tabs") {
    return <TabsView {...props} />
  }

  return null
}, propsAreEqual)

export default CardsView
